import React from "react"

import ToggleButton from '../../form_sections/ToggleButton'
import StandardModal from '../../app_components/StandardModal'

class IdVerificationFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      needVerifyModal: false,
      needVerify: true,
      selected: false,
      loaded: false,
    }

    this.selectIdVerification = this.selectIdVerification.bind(this)
  }

  componentDidMount() {
    this.setState({
      selected: this.props.idVerification != null && this.props.selected,
      needVerify: this.props.idVerification === null,
      loaded: true,
    })
  }

  selectIdVerification() {
    if (this.state.needVerify) {
      this.props.toggleProModal('id')
    } else {
      this.props.toggleIdVerification()
      this.setState({
        selected: !this.state.selected,
      })
    }
  }

  render() {
    if (!this.state.loaded) {
      return null
    }

    return (
      <section className="matchFiltersModal__card">
        {this.state.needVerifyModal && (
          <StandardModal onClose={() => this.setState({ needVerifyModal: false })}>
            <h3 className="matchFiltersModal__alertTitle">Verify your identity</h3>
            <p className="matchFiltersModal__alertText">
              Finish identity verification to use this setting.
            </p>
            <button
              type="button"
              className="button_primary"
              onClick={() => window.location.assign('/verify_identity_steps')}
            >
              Verify identity
            </button>
          </StandardModal>
        )}

        <div className="matchFiltersModal__sectionHeader">
          <h3 className="matchFiltersModal__sectionTitle">Verified connects only</h3>
          <span className="matchFiltersModal__proBadge">Pro</span>
        </div>
        <p className="matchFiltersModal__sectionHint">
          Only verified members can send you connect requests.
        </p>
        <ToggleButton
          selected={this.state.selected}
          pro={true}
          onClick={() => this.selectIdVerification()}
          buttonText="Verified connects only"
        />
      </section>
    )
  }
}

export default IdVerificationFilter
